import { apiClient } from "lib/apiClient";

export const unarchiveMarketAreas = async (ids: string[]): Promise<void> => {
  await apiClient.post("/market-areas/unarchive", ids);
};
